import { render, staticRenderFns } from "./InputTextarea.global.vue?vue&type=template&id=4187fac2&scoped=true&lang=pug&"
import script from "./InputTextarea.global.vue?vue&type=script&lang=ts&"
export * from "./InputTextarea.global.vue?vue&type=script&lang=ts&"
import style0 from "./InputTextarea.global.vue?vue&type=style&index=0&id=4187fac2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4187fac2",
  null
  
)

export default component.exports